import Main from '@/views/administracion/programacion/Main.vue';
import Default from '@/views/administracion/programacion/Default.vue';
import MainOficio from '@/views/administracion/programacion/oficio/Main.vue';
import DefaultOficio from '@/views/administracion/programacion/oficio/Default.vue';

const auth = ['Programación:ver'];
const scopes = ['Programación:crear', 'Programación:editar', 'Programación:eliminar'];

const programacion = [
  {
    path: 'programacion',
    meta: {
      title: '',
      auth,
      scopes,
    },
    component: Main,
    children: [
      {
        name: 'programacion',
        path: '/',
        meta: {
          title: 'Programacion',
          auth,
          scopes,
        },
        component: Default,
        children: [],
      },
      {
        path: ':idOficio',
        meta: {
          title: 'Oficio de Autorización',
          auth,
          scopes,
        },
        component: MainOficio,
        children: [
          {
            name: 'oficioAutorizacion',
            path: '/',
            meta: {
              title: 'Oficio de Autorización',
              auth,
              scopes,
            },
            component: DefaultOficio,
          },
        ],
      },
    ],
  },
];

export default programacion;
